// Painel admin do SaaS: status e validade dos certificados de todos os clientes.
// Nenhum dado sensível chega aqui (nem arquivo, nem senha).
import React, { useEffect, useState } from "react";
import { fiscal } from "../api";
import { Aviso, Cartao, Tabela } from "../components/ui";
import { dataBR, mascaraDocumento } from "../utils";

const COR = {
  ativo: "bg-emerald-100 text-emerald-800",
  vence_em_breve: "bg-amber-100 text-amber-800",
  expirado: "bg-red-100 text-red-700",
};
const ROTULO = { ativo: "Ativo", vence_em_breve: "Vence em breve", expirado: "Expirado" };

export default function AdminCertificados() {
  const [lista, setLista] = useState([]);
  const [erro, setErro] = useState(null);
  useEffect(() => { fiscal.adminCertificados().then(setLista).catch((e) => setErro(e.message)); }, []);

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">Certificados dos clientes</h1>
      {erro && <Aviso tipo="erro">{erro}</Aviso>}
      <Cartao>
        <Tabela
          chave={(l) => l.tenant_id}
          linhas={lista}
          vazio="Nenhum certificado cadastrado"
          colunas={[
            { id: "razao_social", rotulo: "Cliente" },
            { id: "cnpj", rotulo: "CNPJ", render: (l) => (l.cnpj ? mascaraDocumento(l.cnpj) : "—") },
            { id: "status", rotulo: "Status", render: (l) => <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${COR[l.status] || ""}`}>{ROTULO[l.status] || l.status}</span> },
            { id: "valido_ate", rotulo: "Validade", render: (l) => dataBR(l.valido_ate) },
            { id: "dias_restantes", rotulo: "Dias restantes", direita: true },
            { id: "termo", rotulo: "Autorização", render: (l) => (l.termo_versao ? `v${l.termo_versao} · ${dataBR(l.termo_aceito_em)}` : <span className="text-amber-700">Pendente</span>) },
          ]}
        />
      </Cartao>
    </div>
  );
}
